import { AddAirportContractAdditionalFee } from "./add-airport-contract-additional-fee";
import { AddAirportContractContact } from "./add-airport-contract-contact";

export interface AddAirportContractRequest {
    iataCode: string;
    fuelSupplierId: number;
    serviceType: string;
    airportName: string;
    validSince: string,
    validUntil: string,
    itpAgent: string;
    remarks: string;
    contractedAmount: number;
    contractedAmountUnitConverterId: number | null;
    contractedValue: number;
    contractedValueCurrencyId: number | null;
    paymentTerms: number;
    fuelPriceIndexTypeId: number | null;
    fuelPriceIndexId: number | null;
    sapSymbolId: number | null;
    feesLatestValidityPeriodValidSince: string;
    feesLatestValidityPeriodValidUntil: string;
    papIndexId: number | null;
    differential: number;
    differentialCurrencyId: number | null;
    differentialUnitConverterId: number | null;
    hookUpFee: number;
    hookUpFeeCurrencyId: number | null;
    hookUpFeeUnitConverterId: number | null;
    lessThan1000Ltr: number | null;
    lessThan1000LtrCurrencyId: number | null;
    lessThan1000LtrUnitConverterId: number | null;
    noFuel: number | null;
    noFuelCurrencyId: number | null;
    noFuelUnitConverterId: number | null;
    outOfHours: number | null;
    outOfHoursCurrencyId: number | null;
    outOfHoursUnitConverterId: number | null;
    safBlendCheckbox: boolean | null;
    safBlendPercentage: number | null;
    safIndex: string | null;
    safIndexValue: number | null;
    safIndexValueCurrencyId: number | null;
    safIndexUnitConverterId: number | null;
    contacts: AddAirportContractContact[];
    additionalFees: AddAirportContractAdditionalFee[];
}
